import React from "react";
import PropTypes from "prop-types";
import SidebarIconSvg from "./SidebarIconSvg";

const SidebarIconUsers = ({ className, size }) => (
  <SidebarIconSvg className={className} size={size}>
    <circle cx="9" cy="7" r="4" />
    <path d="M3 21v-1a6 6 0 0 1 12 0v1" />
    <path d="M16 3.13a4 4 0 0 1 0 7.75M21 21v-1a4 4 0 0 0-3-3.87" />
  </SidebarIconSvg>
);

SidebarIconUsers.propTypes = {
  className: PropTypes.string,
  size: PropTypes.number
};

export default SidebarIconUsers;
